import S from './Error.styled';

export const ErrorBlock = () => {
  return (
    <S.Wrapper>
      <p>Something went wrong... </p>
      <p>please try again later</p>
    </S.Wrapper>
  );
};
